<pro-header></pro-header>
<pro-nav></pro-nav>
<section class="page-section" >
    <div class="container" >
        <router-outlet></router-outlet>
    </div>
</section>
<pro-footer></pro-footer>